import React, { useEffect, useState } from "react";
import EwalletService from "../../../service/ewallet/Ewallet";
import TransactionListService from "../../../service/transactionList/TransactionList";
import Table from "react-bootstrap/Table";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
//service
import AppInfoservice from "../../../service/common/Appinfo";

//style
import { Row, Col } from "react-bootstrap";

export class ComponentToPrint extends React.PureComponent {
  constructor(props) {
    super(props);
    this.service = new TransactionListService();

    const current = new Date();
    const date = `${current.getDate()}/${
      current.getMonth() + 1
    }/${current.getFullYear()} , ${current.getHours()}:${current.getMinutes()}`;
    // const time = current.getHours() + ':' + current.getMinutes();

    this.state = {
      earnings: {},
      loading: true,
      date: date,
    };
  }

  exportDatas(type, start, end) {
    console.log("api export darta", type, start, end);
    this.service.exportTransactionData(start, end).then((res) => {
      if (res.status) {
        console.log("export transaction data");
        console.log(res.data.result);
        this.setState((prevState) => ({
          ...prevState,
          loading: false,
          earnings: res.data.result,
        }));
      } else {
        this.setState((prevState) => ({
          ...prevState,
          loading: true,
        }));
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.data.filterValues != prevProps.data.filterValues ||
      this.props.data.startDate != prevProps.data.startDate ||
      this.props.data.endDate != prevProps.data.endDate
    ) {
      console.log(
        "export api call goes here",
        this.props.data.startDate,
        this.props.data.endDate
      );
      this.exportDatas(
        "print",
        this.props.data.startDate,
        this.props.data.endDate
      );
    }
  }
  componentDidMount() {
    this.exportDatas(
      "print",
      this.props.data.startDate,
      this.props.data.endDate
    );
  }

  render() {
    return (
      <div style={{ padding: 60 }}>
        <Row>
          <Col>{this.state.date}</Col>
          <Col>
            {/* <h5 style={{ textAlign: "center" }}>User Earnigs Report</h5> */}
            <h5 style={{ textAlign: "center" }}>Store Transaction History</h5>
          </Col>
        </Row>

        <div ref={this.ref}>
          <Row style={{ marginBottom: 50 }}>
            <Col span={8}>
              <img
                src={this.props.company.logo}
                alt="Logo"
                style={{ maxWidth: "120px" }}
              />
              <div>COMPANY NAME : {this.props.company.comapny_name}</div>
              <div>COMPANY ADDRESS : {this.props.company.company_address}</div>
              <div>TELEPHONE : {this.props.company.phone}</div>
              <div>EMAIL : {this.props.company.email}</div>
            </Col>
          </Row>

          {!this.state.loading && this.state.earnings.length > 0 && (
            <Table striped hover>
              <thead>
                <tr>
                  <th>{this.props.t("Common.dateAdded")}</th>
                  <th>{this.props.t("Common.tansactionNo")}</th>
                  <th>{this.props.t("Common.transactionType")}</th>
                  <th>{this.props.t("Common.gross")}</th>
                  <th>{this.props.t("Common.deliveryMode")}</th>
                  <th>Delivery Address</th>
                  <th>Payment Type</th>
                  <th>{this.props.t("Common.status")}</th>
                  <th>Sales Invoice</th>
                  <th>Tracking No</th>
                  <th>Code Status</th>
                  {/* <th>{this.props.t("Common.transactionDate")}</th> */}
                </tr>
              </thead>
              <tbody>
                {this.state.earnings.map((obj, index) => {
                  console.log(obj, "object goes here");
                  return (
                    <tr key={index}>
                      <td>{obj.date_added}</td>
                      <td>
                        {/* {" "}
                        {this.props.Currency.currentCurr} */}
                        {/* {(
                          parseFloat(obj.total_amount) *
                          this.props.Currency.value
                        ).toFixed(this.props.Currency.precision)} */}
                        {obj.order_id}
                      </td>
                      <td>{obj.order_type}</td>
                      {/* <td>{obj.gross}</td> */}
                      <td>
                        {this.props.Currency.currentCurr}
                        {(
                          parseFloat(obj.gross) * this.props.Currency.value
                        ).toFixed(this.props.Currency.precision)}
                      </td>
                      <td>{obj.delivery_mode}</td>
                      <td>{obj.delivery_address}</td>
                      <td>{obj.payment_method}</td>
                      <td>{obj.status}</td>
                      <td>{obj.sales_invoice}</td>
                      <td>{obj.trackingNumber}</td>
                      <td>{obj.codeUsedOrNot}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </div>
      </div>
    );
  }
}

const UserEarningsPrintView = React.forwardRef((props, ref) => {
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();
  const [companyDetails, setCompanyDetails] = useState({});

  const service = new AppInfoservice();

  useEffect(() => {
    service.Appinfo().then((res) => {
      if (res.status) {
        setCompanyDetails((prevState) => ({
          ...prevState,
          logo: res.data.company_info.login_logo,
          comapny_name: res.data.company_info.company_name,
          company_address: res.data.company_info.company_address,
          phone: res.data.company_info.phone,
          email: res.data.company_info.email,
        }));
      }
    });
  }, []);
  return (
    <ComponentToPrint
      ref={ref}
      data={props}
      company={companyDetails}
      Currency={Currency}
      t={t}
    />
  );
});
export default UserEarningsPrintView;
